const state = {
  autoBid: []
}

const mutations = {
  SET_AUTO_BID(state, payload) {
    state.autoBid.push({
      status: payload.status,
      count: payload.count,
      auctionId: payload.auctionId,
      timeToBid: payload.timeToBid
    });
  },
  REMOVE_AUTO_BID(state, payload) {
    state.autoBid.splice(payload, 1)
  },
  UPDATE_AUTOBID_COMMIT: (state, payload) => {
    state.autoBid[payload].count--
  }
}

const actions = {
  SetAutoBid: ({ state, commit }, payload) => {

    // Check if auction is already in the autobid array with Array.prototype.find()
    let autoBidToAdd = state.autoBid.find(i => i.auctionId === payload.auctionId);

    // If find returns undefined that means auction does not exist in the array
    // Add array to the autobid list
    if (autoBidToAdd === undefined) {
      commit("SET_AUTO_BID", payload)
    } else console.error("autobid already activated for this auction")
  },
  RemoveAutoBid: ({ state, commit }, payload) => {

    // find index of auction to be removed
    let autoBidToRemoveIndex = state.autoBid.findIndex(i => i.auctionId === payload.auctionId);
    
    // if index is -1 then auction does not exist in the array list
    if (autoBidToRemoveIndex === -1) {
      console.error("autobid is not active on this auction")
    } else {
      commit("REMOVE_AUTO_BID", autoBidToRemoveIndex);
    }
  },

  updateAutoBidCount: ({ state, commit}, payload) => {
    let autoBidtoUpdateIndex = state.autoBid.findIndex(i => i.auctionId === payload.auctionId);
    if (autoBidtoUpdateIndex === -1) {
      console.log("autobid is not active on this auction");
    } else commit("UPDATE_AUTOBID_COMMIT", autoBidtoUpdateIndex)
  }
}

const getters = {
  autoBidList: state => state.autoBid
}

export default {
  state,
  mutations,
  actions,
  getters
}